// src/components/Contact.jsx
import './Contact.css';
import { CONTACT_TILES } from '../data/content';

export default function Contact() {
  return (
    <section id="contact" className="contact-section">
      {/* Background decoration */}
      <div className="contact-bg-glow" />

      <div className="container contact-inner">

        {/* Bold statement block */}
        <div className="contact-statement fade-in">
          <p className="section-label">Contact Us</p>
          <h2 className="contact-heading">
            Let's build<br />
            <span className="contact-heading-grad">something real.</span>
          </h2>
          <p className="contact-sub">
            No lengthy forms. No waiting rooms.<br />
            Just reach out — we move fast.
          </p>
          <div className="contact-location">
            <span className="location-dot" />
            Noida, India
          </div>
        </div>

        {/* Tiles */}
        <div className="contact-tiles fade-in fade-in-delay-1">
          {CONTACT_TILES.map((tile) => (
            <a
              key={tile.id}
              href={tile.href}
              className="contact-tile"
              target={tile.id === 'whatsapp' ? '_blank' : undefined}
              rel={tile.id === 'whatsapp' ? 'noreferrer' : undefined}
              style={{ '--tile-accent': tile.accent, '--tile-dim': tile.accentDim }}
            >
              <div className="tile-icon">{tile.icon}</div>
              <div className="tile-body">
                <span className="tile-label">{tile.label}</span>
                <span className="tile-value">{tile.value}</span>
                <span className="tile-sub">{tile.sub}</span>
              </div>
              <span className="tile-arrow">→</span>
            </a>
          ))}
        </div>

      </div>
    </section>
  );
}